import React from "react"
import {TextModel} from "models/Text"
import Cashmere25MenuButton, {StyledMenuIcon} from "./components"
import env from "../../../../../../config/env"

interface Cashmere25MenuButtonProps {
    text: TextModel
    disableIcon: boolean
    anchorRef: React.RefObject<HTMLButtonElement>
    open: boolean
    setOpen: (value: React.SetStateAction<boolean>) => void
    buttonText: string
}

const Cashmere25MenuButtonComponent = ({
    text,
    disableIcon,
    anchorRef,
    open,
    setOpen,
    buttonText,
}: Cashmere25MenuButtonProps) => {
    const handleToggle = () => {
        setOpen(prev => !prev)
    }

    return (
        <Cashmere25MenuButton
            aria-controls={open ? "menu-list-grow" : undefined}
            aria-haspopup="true"
            aria-describedby={open ? "styled-options-menu" : undefined}
            onClick={handleToggle}
            ref={anchorRef}
            disableRipple
            disableElevation
            variant="text"
            data-testid={`plp-menu-button-${buttonText.toLowerCase()}`}
        >
            {!open && !disableIcon && (
                <StyledMenuIcon
                    src={`${env.REACT_APP_BLOB_STORAGE_PATH}/icons/pdp/brand/next/sort-m-default.svg`}
                    alt={text.assetsAlt.closeIcon}
                    data-testid="plp-menu-button-icon"
                />
            )}
            <span className="plp-menu-button-text">{open ? text.labels.close : buttonText}</span>
        </Cashmere25MenuButton>
    )
}

export default Cashmere25MenuButtonComponent
